"use strict";

var _slicedToArray = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reactPlugin = void 0;

var react_1 = require("react");

var addFn = function addFn(setters, field, fn) {
  if (!setters[field]) setters[field] = [];
  setters[field].push(fn);
};

var removeFn = function removeFn(collection, fn) {
  for (var i = collection.length - 1; i >= 0; --i) {
    if (collection[i] === fn) {
      collection.splice(i, 1);
    }
  }
};

var reactPlugin = function reactPlugin(lead) {
  var stateSetters = {};

  lead.useField = function (field) {
    var _ref = (0, react_1.useState)(function () {
      return lead.fields.get(field);
    }),
        _ref2 = _slicedToArray(_ref, 2),
        fieldState = _ref2[0],
        setFieldState = _ref2[1];

    var updateField = (0, react_1.useCallback)(function (value) {
      lead.fields.set(field, value);
    }, [field]);
    (0, react_1.useEffect)(function () {
      addFn(stateSetters, field, setFieldState);
      return function () {
        removeFn(stateSetters[field], setFieldState);
      };
    }, [setFieldState, field]);
    return [fieldState, updateField];
  };

  return {
    onFieldUpdate: function onFieldUpdate(key, newValue) {
      if (stateSetters[key]) {
        stateSetters[key].forEach(function (cb) {
          cb(newValue);
        });
      }

      return newValue;
    }
  };
};

exports.reactPlugin = reactPlugin;